import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';

import { Select } from '@shared/components/select/select.component';
import { SelectItem } from '@shared/components/select/select-item.component';
import { SelectOption } from '@shared/components/select/select-option.component';
import { SelectPrefix } from '@shared/components/select/select-prefix.directive';
import { SelectCategory } from '@shared/components/select/select-category.component';
import { SelectLabel } from '@shared/components/select/select-label.directive';
import { SelectOptions } from '@shared/components/select/select-options.directive';
import { SelectOptionLabel } from '@shared/components/select/select-option-label.directive';
import { SpinnerModule } from '@shared/components/spinner/spinner.module';
import { BasicModule } from '@shared/modules/basic.module';
import { SelectSuffix } from '@shared/components/select/select-suffix.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectContainer } from '@shared/components/select/select-container.directive';
import { SelectFooterContent } from '@shared/components/select/select-footer-content.directive';

@NgModule({
  imports: [
    CommonModule,
    PortalModule,
    OverlayModule,

    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatButtonModule,
    MatProgressBarModule,

    BasicModule,
    SpinnerModule,
    MatCheckboxModule,
    MatRadioModule,
  ],
  declarations: [
    Select,
    SelectItem,
    SelectLabel,
    SelectOption,
    SelectOptionLabel,
    SelectOptions,
    SelectPrefix,
    SelectCategory,
    SelectSuffix,
    SelectContainer,
    SelectFooterContent,
  ],
  exports: [
    Select,
    SelectLabel,
    SelectOption,
    SelectOptionLabel,
    SelectOptions,
    SelectPrefix,
    SelectCategory,
    SelectSuffix,
    SelectContainer,
    SelectFooterContent,
  ],
})
export class SelectModule {}
